// components/use-case-details/use-case-workflow/use-case-problem-statement.tsx
// components/use-case-details/use-case-problem-statement.tsx
"use client";

import React from 'react';

interface UseCaseProblemStatementProps {
  title: string;
  subtitle?: string;
  challenges: {
    title: string;
    description: string;
    example?: string;
  }[];
  impactPoints?: string[];
}

const UseCaseProblemStatement: React.FC<UseCaseProblemStatementProps> = ({
  title,
  subtitle,
  challenges,
  impactPoints = []
}) => {
  return (
    <div className="my-12">
      {/* Main header */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-700">{title}</h2>
        {subtitle && <p className="text-xl text-gray-600 mt-2">{subtitle}</p>}
      </div>
      
      {/* Challenges as bullet points with proper indentation */}
      <div className="space-y-8">
        {challenges.map((challenge, index) => (
          <div key={index} className="bg-gray-800 p-6 rounded-lg">
              <div className="flex">
                {/* Bullet point */}
                {/* <span className="text-blue-400 mr-3 mt-1.5 text-xl flex-shrink-0">•</span> */}
              
                {/* Challenge content */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-100 mb-3">{challenge.title}</h3>
                  <p className="text-xl text-gray-300 leading-relaxed mb-3">{challenge.description}</p>
              
                  {challenge.example && (
                    <div className="text-lg text-gray-400 italic">
                      {challenge.example}
                    </div>
                  )}
                </div>
              </div>
          </div>
        ))}
        
        {/* Business Impact Section with matching indentation */}
        {impactPoints && impactPoints.length > 0 && (
          <div className="">
            <div className="flex items-center mb-6 mt-16">
              {/* <AlertTriangle className="text-yellow-500 mr-3" size={24} /> */}
              <h3 className="text-2xl font-bold text-gray-900">Business Impact</h3>
            </div>
            <div className="space-y-3">
              {impactPoints.map((point, idx) => (
                <div key={idx} className="flex">
                  <span className="text-yellow-500 mr-3 mt-1.5 text-xl flex-shrink-0">•</span>
                  <span className="text-xl text-gray-800">{point}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UseCaseProblemStatement;